import { ProjectQueryData } from '../queries/searchPage/searchProjects';
import { ProjectFilterParams } from '../services/search';
import { endpoints } from '../pages/api/endpoints';
import config from '../common/config';
import logger from '../common/helpers/logger/logger';
import { getPriceByQuery } from '../common/helpers/domain/priceOptions';
import { removeEmptyOrUndefinedValues } from '../common/helpers/utility/objectHelper';

export const searchProjects = async (
  offset: number,
  searchQuery: ProjectFilterParams,
  perPage: number,
): Promise<ProjectQueryData['projectListCarouselQuery']> => {
  // Next API Route
  const url = `${config.baseUrl}${endpoints.projects}`;
  const minPrice = getPriceByQuery(searchQuery.minPrice);
  const maxPrice = getPriceByQuery(searchQuery.maxPrice);
  try {
    const queryParams = new URLSearchParams(
      removeEmptyOrUndefinedValues({
        ...searchQuery,
        offset: offset.toString(),
        perPage: perPage.toString(),
        minPrice: minPrice?.toString() || '',
        maxPrice: maxPrice?.toString() || '',
      }),
    );
    const response = await fetch(`${url}?${queryParams.toString()}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const contentType = response.headers.get('content-type');
    if (!contentType || !contentType.includes('application/json')) {
      throw new Error('Invalid response type');
    }

    const data = await response.json();
    return data;
  } catch (error) {
    logger.logError(
      'frontend-service.searchProjects',
      'Error retrieving projectnet data.',
      {
        error,
      },
    );
    return { items: [], totalCount: 0, totalPage: 0 };
  }
};
export const fetchProjectnetSuggestions = async (searchValue: string) => {
  try {
    const response = await fetch(
      `${endpoints.suggestedProjects}/?freeText=${encodeURIComponent(
        searchValue,
      )}`,
    );

    if (!response.ok)
      throw new Error('Failed to fetch projectnet project suggestions');

    const { data } = await response.json();
    return data || [];
  } catch (error) {
    logger.logError(
      'frontend-service.project-api.fetchProjectNetSearchSuggestions',
      'Error retrieving projects.',
      {
        error,
      },
    );
  }
};
